import { atom } from 'jotai';

export const drawerOpenAtom = atom(false);
